import { Box, CircularProgress } from "@mui/material";
import React from "react";

interface Props {
  height?: string;
  inline?: boolean;
  inButton?: boolean;
}

const Loader: React.FC<Props> = (props: Props) => {
  const { height, inline, inButton } = props;

  if (inButton) {
    return <CircularProgress size={20} color="inherit" />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: inline ? "auto" : height,
        width: "100%",
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default Loader;
